import { render, staticRenderFns } from "./src/components/forgot.html?vue&type=template&id=eefc9d18&scoped=true&"
import script from "./src/components/forgot.js?vue&type=script&lang=js&"
export * from "./src/components/forgot.js?vue&type=script&lang=js&"
import style0 from "./src/components/forgot.scss?vue&type=style&index=0&id=eefc9d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefc9d18",
  null
  
)

export default component.exports